import React from 'react';

class CardItem extends React.Component{
    DemoClick(URL){
        this.props.DemoClick(URL)
    }
    render(){
        let items = this.props.item_props;
        return(
            <div className="row">
                {
                    items.map(
                        (item) => 
                        <div className="cell-xl-3">
                            <div>
                                <div className="card image-header">
                                    <div className="card-header fg-white"
                                        style={{backgroundImage: "url(" + item.IMAGE + ")" , height:"16.5rem"}}>                        
                                    </div>
                                    <div className="card-content p-2">
                                        {item.NAME}
                                    </div>
                                    <div className="card-footer">
                                        <button className="button info rounded" onClick={()=>this.DemoClick(item.DEMO)}>Demo</button>
                                        <a className="button warning rounded" href={item.SOURCE} target="_blank">Source</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )
                }
            </div>
        )
    }
}

class IfreamControlles extends React.Component{
    render(){
        return(
            <div className="embed-container" style={{position: "fixed"}}>
                <iframe src= {this.props.ifream_URL} allowfullscreen />
            </div>
        );
    }
}

class CardsControlles extends React.Component{
    constructor(){
        super();
    }
    DemoClick(URL){
        this.props.DemoClick(URL);
    }
    render(){
        let item = [];
        let item_props = [];
        let item_HTML = [];
        this.props.Item.map(
            (Item) => 
            item.push(Item)
        );
        for(let i = 0 ; i<= item.length / 4 ;i++){
            item_props = [];
            for(let j = 0 ; j < 4 ; j++){
                if(item[i*4+j] != null){
                    item_props.push(item[i*4+j]);
                }
            }
            item_HTML.push(<CardItem item_props={item_props} DemoClick={(URL)=>this.DemoClick(URL)}/>);
        } 
        return(            
            <div>
                {item_HTML}
            </div>
        );        
    }
}

export  {CardsControlles,IfreamControlles};